"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDnd = require("react-dnd");

var _Clips = _interopRequireDefault(require("../components/Clips"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DRAG_TYPE = 'box';

function drop(_ref, monitor) {
  var _onClipDrop = _ref.onClipDrop,
      id = _ref.id;
  var xPos = monitor.getSourceClientOffset().x;
  return {
    onClipDrop: function onClipDrop() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _onClipDrop.apply(void 0, args.concat([id]));
    },
    xPos: xPos
  };
}

var dragHandlers = {
  drop: drop
};

function getDragConfig(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var _default = (0, _reactDnd.DropTarget)(DRAG_TYPE, dragHandlers, getDragConfig)(_Clips.default);

exports.default = _default;